module.exports = __webpack_public_path__ + "img/nojiangyi.b90eacb8.png";